
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cruises",
      function () {
        return require("private-next-pages/cruises.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cruises"])
      });
    }
  